<template>
  <h2 :id="content.key" class="title">{{ content.title }}</h2>
</template>
<script>
/*
标题-2
*/
export default {
  name: "title-2",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  margin: 20px 0;
  width: 100%;
  height: 70px;
  background: url(~@/assets/images/bookContent/title_bg_xm.png) center center no-repeat;
  background-size: contain;
  font-size: 28px;
  color: #fff;
  text-align: center;
  line-height: 70px;
}
</style>